import { AxiosResponse } from "axios";
import { BaseSchool } from "./bases/base.service";

export default class SchoolService {}
